import { render, staticRenderFns } from "./ChooseSubject.vue?vue&type=template&id=d5dad188&scoped=true&"
import script from "./ChooseSubject.vue?vue&type=script&lang=js&"
export * from "./ChooseSubject.vue?vue&type=script&lang=js&"
import style0 from "./ChooseSubject.vue?vue&type=style&index=0&id=d5dad188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dad188",
  null
  
)

export default component.exports